export default __webpack_public_path__ + "static/team3-b26ea03987d2cdfc20d9f1268677dcf5.jpg";